<div *ngIf="isModalShown" [config]="{ show: true, ignoreBackdropClick: true, animated: false, keyboard: closeOnEscape, backdrop: showBackdrop }" class="modal fade wm-studio-dialog" (onHidden)="hideModal()" [ngClass]="customClasses" bsModal  tabindex="-1" role="dialog" aria-labelledby="wm-studio-dialog" #wmsDialog="bs-modal">
    <div class="modal-dialog app-dialog" [attr.dialogid]="dialogid" [ngClass]="position">
        <div class="modal-content">
            <ng-content [context]="dialogParams"></ng-content>
            <ng-container *ngIf="content" [ngTemplateOutlet]="content" [ngTemplateOutletContext]="dialogParams">
            </ng-container>
        </div>
    </div>
</div>
